import { from, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DraftFacade } from '@classifieds-sell/state';
import { CategoryEnum, Metadata } from 'libs/datalayer/src';

export abstract class PropertySectionBase {
    private _sectionbaseDestroyed$: Subject<void> = new Subject<void>();

    public draftLoaded$: Observable<boolean>;

    originalDraftData: any;
    categoryId: CategoryEnum;
    draftData: any;
    validation: any;
    metadata: Metadata;
    isUntilWithdrawn: boolean; // Indicates if the duration of the listing is until-withdrawn

    abstract isValid(): boolean;

    abstract dirty(): boolean;

    constructor(public draftFacade: DraftFacade) { }

    protected onInit(subscription?: () => void): void {
        this.draftLoaded$ = this.draftFacade.draftLoaded$;
        this.getDraft(subscription);
    }

    protected onDestroy(): void {
        this._sectionbaseDestroyed$.next();
    }

    private getDraft(subscription?: () => void): void {
        from(this.draftFacade.state$)
            .pipe(takeUntil(this._sectionbaseDestroyed$))
            .subscribe((state) => {
                if (state.draftLoaded) {
                    // deep clone to make sure nested properties are still mutable
                    this.draftData = JSON.parse(
                        JSON.stringify(state.draftData)
                    );
                    this.originalDraftData = JSON.parse(
                        JSON.stringify(state.originalDraftData)
                    );
                    this.validation = { ...state.validationSchema };
                    this.metadata = { ...state.metadata };
                    this.categoryId = state.categoryId;
                    this.isUntilWithdrawn = this.metadata.isUntilWithdrawn;
                }

                if (
                    this.draftData &&
                    Object.keys(this.draftData).length !== 0 &&
                    this.validation &&
                    Object.keys(this.validation).length !== 0
                ) {
                    // invoke if there is subscription
                    if (subscription) {
                        subscription();
                    }
                }
            });
    }

    publish = (): void => {
        this.draftFacade.updateDraftData(this.draftData);
    };
}
